var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_8218)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_71_8218)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 51,
    r: 51,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67 50.5L43.75 63.9234L43.75 37.0766L67 50.5Z",
    fill: "#3E71EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_71_8218",
    x: -43.1,
    y: -43.1,
    width: 188.2,
    height: 188.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 21.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_71_8218"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_71_8218",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_8218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    rx: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/play-btn.c9ce118a2a469baca0a3df519eaefe47.svg";
export { ForwardRef as ReactComponent };